import { AccountType } from '../../types'
import { Token } from '@/domain/types/Token'

export function savingsTokenToAccountType(token: Token): AccountType {
  switch (token.symbol) {
    case 'sUSDS':
      return 'susds'
    case 'sUSDC':
      return 'susdc'
    case 'sDAI':
      return 'sdai'
    case 'stUSDS':
      return 'stusds'
    case 'spUSDC':
      return 'spusdc'
    case 'spUSDT':
      return 'spusdt'
    case 'spETH':
      return 'speth'
    case 'spPYUSD':
      return 'sppyusd'
    default:
      return 'susds'
  }
}
